export const TA_METRICS_TOOLTIP_ITEMS = [
  { label: 'Active TA', description: 'Total of TAs who have a booking of any status created in the past 12 months.' },
  { label: 'Logged In TA', description: 'Total of TAs who logged into the app per month.' },
  { label: 'New TA', description: 'Total of new TAs published each month.' },
];
